import { PayloadAction, createSlice } from "@reduxjs/toolkit";
import { POPUP_CONTENT } from "src/utils/types";

interface popupState {
    popupInfo: POPUP_CONTENT;
}

const initialState: popupState = {
    popupInfo: {
        show: false,
        type: "",
        title: "",
        subTitle: "",
        okBtnText: "",
        img: "",
        mobileImg: "",
        body: "",
        withButton: false,
        errorStatus: 0
    }
};

/* eslint-disable no-param-reassign */
const popupSlice = createSlice({
    name: "popup",
    initialState,
    reducers: {
        setPopupInfo: (state, action: PayloadAction<POPUP_CONTENT>) => {
            state.popupInfo = action.payload;
        },
        resetPopupInfo: (state) => {
            state.popupInfo = initialState.popupInfo;
        }
    }
});

export const { setPopupInfo, resetPopupInfo } = popupSlice.actions;
export default popupSlice.reducer;
